<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    title="任务入库"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <!-- 表单数据 -->
    <a-form
      name="form"
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 18 }"
    >
      <template v-if="detail.pay_type === 1 || detail.pay_type === 3">
        <!-- IAP -->
        <div class="group-title">IAP （ 毛利{{ (detail.iap_provider_commission_rate - (formState.iap || 0)).toFixed(2) }}% ）</div>
        <!-- 可分成 -->
        <a-form-item class="form-item-nohint" label="可分成">{{ detail.iap_commission_rate_api }}%（其中服务商占比{{ detail.service_provider_rate_api }}%）</a-form-item>
        <!-- 服务商星图分成 -->
        <a-form-item class="form-item-nohint" label="服务商星图分成">{{ detail.iap_provider_commission_rate }}%</a-form-item>
        <!-- 达人星图分成 -->
        <a-form-item class="form-item-nohint" label="达人星图分成">{{ detail.iap_xt_commission_rate }}%</a-form-item>
        <!-- 达人云想分成 -->
        <a-form-item
          label="达人云想分成"
          name="iap"
          :rules="[{ required: true, message: '请输入' }]"
        >
          <a-input
            v-model:value="formState.iap"
            placeholder="请输入"
            suffix="%"
            @input="handleInputIap"
          />
        </a-form-item>
      </template>
      <template v-if="detail.pay_type === 2 || detail.pay_type === 3">
        <!-- IAA -->
        <div class="group-title">IAA （ 毛利{{ (detail.iaa_provider_commission_rate - (formState.iaa || 0)).toFixed(2) }}% ）</div>
        <!-- 可分成 -->
        <a-form-item class="form-item-nohint" label="可分成">{{ detail.iaa_commission_rate_api }}%（其中服务商占比{{ detail.service_provider_rate_api }}%）</a-form-item>
        <!-- 服务商星图分成 -->
        <a-form-item class="form-item-nohint" label="服务商星图分成">{{ detail.iaa_provider_commission_rate }}%</a-form-item>
        <!-- 达人星图分成 -->
        <a-form-item class="form-item-nohint" label="达人星图分成">{{ detail.iaa_xt_commission_rate }}%</a-form-item>
        <!-- 达人云想分成 -->
        <a-form-item
          label="达人云想分成"
          name="iaa"
          :rules="[{ required: true, message: '请输入' }]"
        >
          <a-input
            v-model:value="formState.iaa"
            placeholder="请输入"
            suffix="%"
            @input="handleInputIaa"
          />
        </a-form-item>
      </template>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-tooltip v-if="isModify" :title="!checkTimeValid() ? '只能操作8小时内的任务' : ''">
        <a-button 
          type="primary" 
          @click="touchSubmit"
          :disabled="!checkTimeValid()"
        >确定</a-button>
      </a-tooltip>
      <a-button
        v-else
        type="primary" 
        @click="touchSubmit"
      >确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, defineExpose, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import { storageSet, storageSetModify } from '@/api/request'
import Pub from '@/utils/public'
import Loading from '@/components/Loading'
import dayjs from 'dayjs'

// 回调
const emit = defineEmits('success')
// 表单实例
let RefForm = ref(null)
// 是否展示弹窗
let visible = ref(false)
// 是修改
let isModify = ref(false)
// 操作ids
let ids = ref([])
// 详情
let detail = ref({})
// 表单数据
let formState = reactive({
  // iap 分成
  iap: undefined,
  // iaa 分成
  iaa: undefined,
})
// 加载
let isLoading = ref(false)

// 打开抽屉
function showDrawer (infoids, info, ismodify) {
  console.log(infoids, info, ismodify);
  
  // 展开
  visible.value = true
  // 记录
  isModify.value = ismodify
  ids.value = infoids
  detail.value = info
  // 赋值
  nextTick(() => {
    if (info.iap_yx_commission_rate) {
      formState.iap = info.iap_yx_commission_rate
    }
    if (info.iaa_yx_commission_rate) {
      formState.iaa = info.iaa_yx_commission_rate
    }
  })
}

// 关闭弹窗
function onClose () {
  // 重置表单
  RefForm.value.resetFields()
  formState.iaa = undefined
  formState.iap = undefined
  visible.value = false
}

// 检查时间是否在8小时内
function checkTimeValid() {
  if (!detail.value.store_date) return false
  const storeTime = dayjs(detail.value.store_date)
  const now = dayjs()
  const diffHours = storeTime.diff(now, 'hour')
  return diffHours >= 0 && diffHours <= 8
}

// 提交
function touchSubmit () {
  // 手动触发表单验证
  RefForm.value.validate()
  .then(() => {
    const params = {
        channel_id: detail.value.channel_id,
        service_provider_rate_api: detail.value.service_provider_rate_api,
        iap_commission_rate_api: detail.value.iap_commission_rate_api,
        iap_provider_commission_rate: detail.value.iap_provider_commission_rate,
        iap_xt_commission_rate: detail.value.iap_xt_commission_rate,
        iap_yx_commission_rate: formState.iap,
        iaa_commission_rate_api: detail.value.iaa_commission_rate_api,
        iaa_provider_commission_rate: detail.value.iaa_provider_commission_rate,
        iaa_xt_commission_rate: detail.value.iaa_xt_commission_rate,
        iaa_yx_commission_rate: formState.iaa,
      }
    if (isModify.value) {
      isLoading.value = true
      storageSetModify({id: ids.value[0], ...params}).then(res => {
        isLoading.value = false
        const { code, msg, data } = res
        if (code === 0) {
          message.success('操作成功')
          // 更新父组件
          emit('success')
          // 关闭弹窗
          onClose()
        } else {
          message.error(res.message || msg)
        }
      })
    } else {
      isLoading.value = true
      storageSet({ids: ids.value, ...params}).then(res => {
        isLoading.value = false
        const { code, msg, data } = res
        if (code === 0) {
          message.success('入库成功')
          // 更新父组件
          emit('success')
          // 关闭弹窗
          onClose()
        } else {
          message.error(res.message || msg)
        }
      })
    }
  })
}

// 限制输入
function handleInputIap(e) {
  formState.iap = Pub.INPUT_NUMBER({value: e.target.value, max: detail.value.iap_provider_commission_rate})
}
// 限制输入
function handleInputIaa(e) {
  formState.iaa = Pub.INPUT_NUMBER({value: e.target.value, max: detail.value.iaa_provider_commission_rate})
}

defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>
.group-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 15px;
}
.form-item-nohint {
  margin-bottom: 6px !important;
}
</style>